import { Box } from "@mui/material";
import React from "react";

import AppointmentsChart from "./AppointmentsChart";
import PatientsChart from "./PatientsChart";
import RevenueSourcesChart from "./RevenueSourcesChart";
import SummaryCards from "./SummaryCards";

const DashboardCharts: React.FC = () => {
  return (
    <Box>
      {/* Summary Cards */}
      <SummaryCards />

      {/* Charts Grid */}
      <Box className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Patients Chart - Top Left */}
        <PatientsChart />

        {/* Appointments Chart - Top Right */}
        <AppointmentsChart />

        {/* Revenue Sources Chart - Bottom (Full Width) */}
        <RevenueSourcesChart className="lg:col-span-2" />
      </Box>
    </Box>
  );
};

export default DashboardCharts;
